import { EpimsBaseEntityDto } from './epim-base.dto';
export class ActivityStatusDto extends EpimsBaseEntityDto {

    ActivityStatusId: string;

    ActivityStatusName: string;
    SubscriberId: string;
    SubscriptionUserId: string;
    dateCreated: Date;
  dateUpdated?: Date;
  CreatedById: string;
  ModifiedById: string;
  SiteId: string;
  Version: number;
}